function groupArrayOfObjectsBy(list: any[], key: string) {
  return list.reduce(function (runningGroupedList, currentListItem) {
    (runningGroupedList[currentListItem[key]] =
      runningGroupedList[currentListItem[key]] || []).push(currentListItem);
    return runningGroupedList;
  }, {});
}

const getFormDataFromObject = <T extends Record<string, any>>(object: T): FormData =>
    Object.keys(object).reduce((formData, key) => {
      const value = object[key as keyof T];
  
      if (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return formData;
      }
  
      if ((value as any) instanceof Date) {
        // You can use toISOString() or split to get just the date part
        formData.append(key, value.toISOString()); // or value.toISOString().split('T')[0]
      } else {
        formData.append(key, value);
      }
      
      return formData;
    }, new FormData());


// const getFormData = (object: any) => Object.keys(object).reduce((formData, key) => {
//     if (!object[key] || (Array.isArray(object[key]) && object[key].length <= 0))
//         return formData

//     formData.append(key, object[key]);
//     return formData;
// }, new FormData());

const getPathWithBaseURL = (filePath: string) : string => {
    return `${process.env.REACT_APP_BaseApiUrl}/${filePath}`;
}

export default groupArrayOfObjectsBy;
export{
    getFormDataFromObject,
    getPathWithBaseURL
}
